import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@design-system-coopeuch/web';
import ClaveDinamicaSMSContenedor from './styles';
import IngresoClaveSMS from '../IngresoClaveSMS';
import LoadIcon from '../../../assets/img/load.svg';
import IconError from '../../../assets/img/icon-error.svg';
import ErrorGenerico from '../../atoms/ErrorGenerico';

const ClaveDinamicaSMS = ({
  onFinished,
  onRetry,
  loading,
  celular,
  estado,
  casoBordeIntentosFallidos,
  casoBordeErrorGenerico,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (!loading) {
      setIsMounted(true);
    }
  }, [loading]);


  return (
    <ClaveDinamicaSMSContenedor
      loading={loading}
      isMounted={isMounted}
      casoBordeIntentosFallidos={casoBordeIntentosFallidos}
    >
      <div className="loading-container">
        <img src={LoadIcon} alt="Loading" />
      </div>
      <Card className="card">
        <h1>Mensaje de texto SMS</h1>
        <CardContent className="card-content">
          {casoBordeErrorGenerico ? (
            <ErrorGenerico />
          ) : (
            <>
              <p className="p-mensaje">
                {estado
                  ? '¡Clave dinámica SMS validada exitosamente! Presiona el botón "Pagar" para realizar la transacción.'
                  : 'Para finalizar y por tu seguridad, necesitamos que ingreses la clave que fue enviada via SMS al celular'}
                <span className="span-mensaje-celular">
                  {` +569****${celular.toString().slice(-4)}`}.
                </span>
              </p>
              <label className="label-titulo">Clave dinámica SMS</label>
              <IngresoClaveSMS
                length={6}
                status={estado}
                onFinished={(clave) => onFinished(clave)}
                durationInSeconds={120}
                loading={loading}
                errorMessage={'La clave ingresada es incorrecta. '}
                successMessage={'Clave dinámica ingresada correctamente.'}
                helperText={'para ingresar tu clave.'}
                onRetry={onRetry}
                maxLengthPerInput={1}
                casoBordeIntentosFallidos={casoBordeIntentosFallidos}
              />
              <div className="caso-borde-intentos">
                <div className="titulo">
                  <img src={IconError} alt="error" />
                  <span>Has excedido el límite de intentos.</span>
                </div>
                <div className="descripcion">
                  <p className="p-descripcion">
                    Tu clave dinámica SMS se encuentra bloqueada. Para desbloquearla, llámanos al{' '}
                    <span className="numero-atencion">600 200 1200.</span>
                  </p>
                </div>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </ClaveDinamicaSMSContenedor>
  );
};

ClaveDinamicaSMS.propTypes = {
  onFinished: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  celular: PropTypes.number.isRequired,
  estado: PropTypes.bool.isRequired,
};

export default ClaveDinamicaSMS;
